import { tagColors } from "@/components/tag/tag-colors";
export const AdTypeEnum = {
  SP: 0,
  SD: 1,
  SB: 2,
};

export const AdWarnEnum = {
  IN_STOCK: {
    name:'有货',
    text:null
  },
  OUT_OF_STOCK: {
    name:'缺货',
    text:'缺货商品通常不会出现在广告中。没有首选商品的商品也被视为缺货。尽管有货状态可能被错误地列为“缺货”，但仍可以将具有区域配送优惠的 ASIN 添加到此工具中的广告活动中。'
  },
  IN_STOCK_SCARCE: {
    name:'低库存',
    text:'商品当前有库存，但是库存水平有限，即将缺货。'
  },
  PREORDER: {
    name:'可预定',
    text:'该商品尚不可用，但可以预定。'
  },
  LEADTIME: {
    name:'交货后可用',
    text:'该商品仅在一定的提前期后可用，即在完成交货后可用。'
  },
  AVAILABLE_DATE: {
    name:'未来可用',
    text:'该商品尚不可用，但将在未来的日期可用。'
  },
  NO: {
    name:'无库存信息',
    text:'商品的供应状态无法确定或未定义。这并不一定意味着商品无货。例如，不可直接购买的父 ASIN 可能拥有此状态。'
  },
};

export const AdStrategyStatusEnum = {
  OPEN: 0,
  CLOSE: 1,
  NO_ADD: 2,

  option: [
    {id: 0, text: '已开启'},
    {id: 1, text: '已关闭'},
    {id: 2, text: '未添加'},
  ],
};

const AdStatus = {
  ENABLE: 0,
  PAUSE: 1,
  ARCHIVE: 2,
  ENABLE_PAUSE: 4
};
const AdStatusNew = {
  ENABLE: '[0]',
  PAUSE: '[1]',
  ARCHIVE: '[2]',
  ENABLE_PAUSE: '[0, 1]'
};
const AdSbStatusNew = {
  ENABLE: 0,
  PAUSE: 1,
  ARCHIVE: 2,
  ENABLE_PAUSE: 3
};

const AdStatusOption = [
  {id: 0, text: '进行中'},
  {id: 1, text: '暂停中'},
  {id: 4, text: '进行/暂停'},
  {id: 2, text: '已归档'}
];

const AdStatusOptionNew = [
  {id: '[0]', text: '进行中'},
  {id: '[1]', text: '暂停中'},
  {id: '[0, 1]', text: '进行/暂停'},
  {id: '[2]', text: '已归档'}
];

const negStatus = {
  ENABLE: 0,
  ARCHIVE: 2,
};

const negStatusOption = [
  {id: 0, text: '启用'},
  {id: 2, text: '已归档'},
];


const negStatusNew = {
  ENABLE: '[0]',
  ARCHIVE: '[2]',
};

const negStatusOptionNew = [
  {id: '[0]', text: '启用'},
  {id: '[2]', text: '已归档'},
];


export const AdCampaignEnum = {
  SP: {
    targetingType: {
      AUTO: 1,
      MANUAL: 0
    },
    targetingTypeOption: [
      {id: 1, text: '自动投放', color: '#34bfa3'},
      {id: 0, text: '手动投放', color: '#5986fb'},
    ],
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},//商品广告
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
      {id: 'ADVERTISER_PAUSED', text: '广告账户已暂停'},
      {id: 'ADVERTISER_ARCHIVED', text: '广告账户已关闭'},
      {id: 'ADVERTISER_PAYMENT_FAILED', text: '广告账户支付失败'},
      {id: 'STATUS_UNAVAILABLE', text: '未知状态'},
      {id: 'ADVERTISER_STATUS_ENABLED', text: '广告账户已启用'},
      {id: 'ADVERTISER_POLICING_PENDING_REVIEW', text: '广告账户待审核'},
      {id: 'ADVERTISER_POLICING_SUSPENDED', text: '广告账户审核挂起'},
      {id: 'ADVERTISER_OUT_OF_PREPAY_BALANCE', text: '广告账户超出预付费用'},
      {id: 'ADVERTISER_EXCEED_SPENDS_LIMIT', text: '广告账户花费超出每日限额'},
      {id: 'PORTFOLIO_STATUS_ENABLED', text: '正在投放'},
      {id: 'PORTFOLIO_PAUSED', text: '广告组合已暂停'},
      {id: 'PORTFOLIO_ENDED', text: '广告组合已结束'},
      {id: 'PORTFOLIO_ARCHIVED', text: '广告组合已归档'},
      {id: 'PORTFOLIO_OUT_OF_BUDGET', text: '广告组合超出预算'},
      {id: 'PORTFOLIO_PENDING_START_DATE', text: '广告组合未开始'},
      {id: 'REJECTED', text: '审核拒绝'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'AD_GROUP_INCOMPLETE', text: '广告组不完整'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_STATUS_ENABLED', text: '正在投放'},
      {id: 'AD_GROUP_LOW_BID', text: '广告组竞价低于最低限价'},
      {id: 'AD_ARCHIVED', text: '已归档'},
      {id: 'AD_PAUSED', text: '已暂停'},
      {id: 'AD_POLICING_PENDING_REVIEW', text: '待审核'},
      {id: 'AD_POLICING_SUSPENDED', text: '审核挂起'},
      {id: 'AD_STATUS_LIVE', text: '正在投放'},
      {id: 'INELIGIBLE', text: '不符合条件'},
      {id: 'ELIGIBLE ', text: '符合条件'},
      {id: 'MISSING_DECORATION', text: '缺少详情'},
      {id: 'MISSING_IMAGE', text: '缺少图片'},
      {id: 'NOT_BUYABLE', text: '不可购买'},
      {id: 'OUT_OF_STOCK', text: '缺货'},
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '启用'},
      {id: 'TARGETING_CLAUSE_BLOCKED', text: '已屏蔽'},
      {id: 'NO_INVENTORY', text: '广告商品缺货'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '审核挂起'},
      {id: 'KEYWORDS_PAUSED', text: '已暂停'},
      {id: 'PRODUCT_TARGETING_PAUSED', text: '已暂停'},
      {id: 'PRODUCT_TARGETING_ARCHIVED', text: '已归档'},
      {id: 'AD_GROUP_POLICING_PENDING_REVIEW', text: '广告组待审核'},
      {id: 'AD_GROUP_POLICING_CREATIVE_REJECTED', text: '广告组审核拒绝'},
      {id: 'AD_STATUS_PAUSED', text: '已暂停'},
      {id: 'AD_STATUS_ARCHIVED', text: '已归档'},
      {id: 'NOT_IN_BUYBOX', text: '无购物车'},
      {id: 'NOT_IN_POLICY', text: '不符合广告政策'},
      {id: 'TARGET_STATUS_LIVE', text: '启用'},
      {id: 'TARGET_STATUS_ARCHIVED', text: '已归档'},
      {id: 'TARGET_STATUS_PAUSED', text: '已暂停'},
      {id: 'ended', text: '已结束'},
      {id: 'landingPageNotAvailable', text: '落地页不可用'},
      {id: 'portfolioOutOfBudget', text: '广告组合超出预算'},
      {id: 'drafts', text: '草稿'},
      {id: 'draft ', text: '草稿'},
      {id: 'portfolioEnded', text: '广告组合已结束'},
      {id: 'other', text: '其他'},
      {id: 'OTHER', text: '其他'},
      {id: 'campaignIncomplete', text: '广告活动不完整'},
      {id: 'unknown', text: '未知状态'},
      {id: 'UNKNOWN', text: '未知状态'},
      {id: 'PENDING_REVIEW', text: '待审核'},
      {id: 'enabled', text: '启用'},
      {id: 'pending', text: '待审核'},
      {id: 'archived', text: '已归档'},
      {id: 'SUBMITTED_FOR_MODERATION', text: '已提交'},
      {id: 'PENDING_MODERATION_REVIEW', text: '待审核'},
      {id: 'APPROVED_BY_MODERATION', text: '审核通过'},
      {id: 'REJECTED_BY_MODERATION', text: '审核拒绝'},
      {id: 'PUBLISHED', text: '已发布'},
    ]
  },
  SB: {
    targetingType: {
      AUTO: 1,
      MANUAL: 0
    },
    budget: { // 每日预算
      support: ['1', '2', '5', '4', '7', '9', '10', '12'],
      msg: '当状态为进行中、已暂停才能调整预算'
    },
    endDate: { // 结束时间
      support: ['1', '2', '5', '4', '7', '9', '10', '12'],
      msg: '当状态为进行中、已暂停才能调整结束时间'
    },
    enable: { // 启用
      support: ['1', '2', '5', '12'],
      msg: '当状态为已暂停才能启用'
    },
    pause: { // 暂停
      support: ['4', '7', '9', '10'],
      msg: '当状态为进行中才能暂停'
    },
    archive: { // 归档
      support: ['0', '3', '8', '4', '7', '9', '10', '1', '2', '5', '12'],
      msg: '当状态为审核中、创建中不能归档'
    },
    movePortfolio: { // 移动分组
      support: ['0', '3', '8', '4', '7', '9', '10', '1', '2', '5', '12'],
      msg: '当状态为审核中、创建中不能移动分组'
    },
    campaignName: { // 编辑广告名称
      support: ['4', '7', '9', '10', '1', '2', '5', '12'],
    },
    // 视频广告支持的站点: 墨西哥、英国、德国、加拿大、澳大利亚、美国
    marketVideo: [
      'US','UK','DE', 'CA', 'MX', 'AU'
    ],
    targetingTypeOption: [
      {id: 1, text: '自动投放', color: '#34bfa3'},
      {id: 0, text: '手动投放', color: '#5986fb'},
    ],
    status: AdSbStatusNew,
    statusOption: [
      {id: 0, text: '进行中'},
      {id: 1, text: '暂停中'},
      {id: 2, text: '已归档'},
      {id: 3, text: '进行/暂停'},
      {id: 4, text: '创建中'},
      {id: 5, text: '审核中'},
      {id: 6, text: '审核失败'},
    ],
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    optionsServe: [
      {id: 0, text: "ASIN出错"},
      {id: 1, text: "账户异常"},
      {id: 2, text: "已结束"},
      {id: 3, text: "着陆页无法应用"},
      {id: 4, text: "超出预算"},
      {id: 5, text: "已暂停"},
      {id: 6, text: "审核中"},
      {id: 7, text: "正在投放"},
      {id: 8, text: "审核失败"},
      {id: 9, text: "正在投放"},
      {id: 10, text: "正在投放"},
      {id: 11, text: "已归档"},
      {id: -1, text: "创建中"},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
      {id: 'OTHER', text: '其他'}
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingType: {
      AUDIENCES: 'T00030',
      PRODUCT_TARGETING: 'T00020'
    },
    targetingTypeOption: [
      {id: 'T00020', text: '商品投放'},
      {id: 'T00030', text: '受众'},
      {id: 'remarketing', text: '再营销'},
    ],
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'}
    ]
  }
};

export const AdGroupEnum = {
  SP: {
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_GROUP_ARCHIVED', text: '已归档'},
      {id: 'AD_GROUP_PAUSED', text: '已暂停'},
      {id: 'AD_GROUP_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '广告活动未完成'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDING_PAGE_NOT_AVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'ENABLED', text: '正在投放'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
    ],
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    targetingType: {
      KEYWORD: 0,
      PRODUCT: 1,
      AUTO: 2,
      ALL: 99
    },
    targetingTypeOption: [
      {id: 0, text: '关键词投放'},
      {id: 1, text: '商品投放'},
      {id: 2, text: '自动投放'},
    ],
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingType: {
      AUDIENCES: 'T00030',
      PRODUCT_TARGETING: 'T00020'
    },
    targetingTypeOption: [
      {id: 'T00020', text: '商品投放'},
      {id: 'T00030', text: '受众'},
      {id: 'remarketing', text: '再营销'},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_GROUP_ARCHIVED', text: '已归档'},
      {id: 'AD_GROUP_PAUSED', text: '已暂停'},
      {id: 'AD_GROUP_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '广告活动未完成'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDING_PAGE_NOT_AVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'ENABLED', text: '正在投放'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
    ],
  }
};

export const AdProductEnum = {
  SP: {
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    targetingTypeOption: [
      {id: 0, text: '关键词投放'},
      {id: 1, text: '商品投放'},
      {id: 2, text: '自动投放'},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_ARCHIVED', text: '已归档'},
      {id: 'AD_PAUSED', text: '已暂停'},
      {id: 'AD_STATUS_LIVE', text: '正在投放'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'MISSING_DECORATION', text: '不符合条件'},
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_ARCHIVED', text: '已归档'},
      {id: 'AD_PAUSED', text: '已暂停'},
      {id: 'AD_STATUS_LIVE', text: '正在投放'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'MISSING_DECORATION', text: '不符合条件'},
    ]
  }
};

export const AdKeywordEnum = {
  SP: {
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    matchType: {
      EXACT: 0,
      PHASE: 1,
      BROAD: 2,
    },
    matchTypeOption: [
      {id: 0, text: '精确匹配', ...tagColors.green},
      {id: 1, text: '词组匹配', ...tagColors.violet},
      {id: 2, text: '广泛匹配', ...tagColors.orange},
    ],
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ],
    bidType: {
      SUGGEST: 0,
      DEFAULT: 1
    },
    bidTypeOption: [
      {id: 0, text: '建议竞价'},
      {id: 1, text: '默认竞价'}
    ]
  },
  SB: {
    status: AdSbStatusNew,
    statusOption: [
      {id: 0, text: '进行中'},
      {id: 1, text: '暂停中'},
      {id: 2, text: '已归档'},
      {id: 3, text: '进行/暂停'},
    ],
    matchType: {
      EXACT: 0,
      PHASE: 1,
      BROAD: 2,
    },
    matchTypeOption: [
      {id: 0, text: '精确匹配', color: '#5986fb'},
      {id: 1, text: '词组匹配', color: '#34bfa3'},
      {id: 2, text: '广泛匹配', color: '#afbacb'},
    ],
    matchTypeOptionNew: [
      {id: 2, text: '广泛', color: '#afbacb'},
      {id: 1, text: '词组', color: '#34bfa3'},
      {id: 0, text: '精确', color: '#5986fb'},
    ],
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ],
    bidType: {
      SUGGEST: 0,
      DEFAULT: 1
    },
    bidTypeOption: [
      {id: 0, text: '建议竞价'},
      {id: 1, text: '默认竞价'}
    ]
  },
};

export const AdTargetEnum = {
  SP: {
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    targetTypeOption: [
      {id: 'QUERY_HIGH_REL_MATCHES', text: '紧密匹配', help: '我们会向使用与您的产品密切相关的搜索字词的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们会在购物者使用“棉床单”和“400支床单”等搜索字词时展示广告。'},
      {id: 'QUERY_BROAD_REL_MATCHES', text: '宽泛匹配', help: '买家使用与您的商品并不密切相关的搜索词进行搜索时，我们会向其显示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在买家使用“bed sheets”、“bath sheets”和“bath towels”等搜索词时展示广告。'},
      {id: 'ASIN_SUBSTITUTE_RELATED', text: '同类商品', help: '买家查看与您的商品类似的商品的详情页面时，我们会向其展示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在包含“300-count Cotton Sheets”和“Queen 400-count Sheets”的商品详情页上展示广告。'},
      {id: 'ASIN_ACCESSORY_RELATED', text: '关联商品', help: '我们会向查看与您的产品相辅相成的产品详细信息页面的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们将在包括“大床被”和“羽绒枕”的详细信息页面上展示广告。'}
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  }
};

export const AdProductTargetEnum = {
  SP: {
    status: AdStatus,
    statusNew: AdStatusNew,
    statusOption: AdStatusOption,
    statusOptionNew: AdStatusOptionNew,
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  },
  SB: {
    status: AdSbStatusNew,
    statusOption: [
      {id: 0, text: '进行中'},
      {id: 1, text: '暂停中'},
      {id: 2, text: '已归档'},
      {id: 3, text: '进行/暂停'},
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ],
    stateOption: [
      {id: 0, text: '启动'},
      {id: 1, text: '已暂停'},
      {id: 2, text: '归档'},
      {id: 3, text: '草稿'}
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  }
};

export const AdNegKeywordEnum = {
  SP: {
    status: negStatus,
    statusNew: negStatusNew,
    statusOption: negStatusOption,
    statusOptionNew: negStatusOptionNew,
    matchType: {
      NEGATIVE_EXACT: 0,
      NEGATIVE_PHRASE: 1
    },
    matchTypeOption: [
      { id: 0, text: '否定精确', color: tagColors.blue.color },
      { id: 1, text: '否定词组', color: tagColors.orange.color },
    ],
    commodityPositioningOption:[
      {id:0,text:'排除ASIN',color:'#34bfa3'}
    ],
    dimension: {
      CAMPAIGN: 0,
      GROUP: 1
    },
    dimensionOption: [
      {id: 0, text: '广告活动'},
      {id: 1, text: '广告组'}
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},

    ]
  },
  SB: {
    status: negStatus,
    statusOption: negStatusOption,
    matchType: {
      NEGATIVE_EXACT: 0,
      NEGATIVE_PHRASE: 1
    },
    matchTypeOption: [
      { id: 0, text: '否定精确', color: tagColors.blue.color },
      { id: 1, text: '否定词组', color: tagColors.orange.color },
    ],
    dimension: {
      CAMPAIGN: 0,
      GROUP: 1
    },
    dimensionOption: [
      {id: 0, text: '广告活动'},
      {id: 1, text: '广告组'}
    ],
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},

    ]
  }
};

export const AdNegTargetEnum = {
  SP: {
    status: negStatus,
    statusNew: negStatusNew,
    statusOption: negStatusOption,
    statusOptionNew: negStatusOptionNew,
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},

    ]
  },
  SB: {
    status: negStatus,
    statusOption: negStatusOption,
    servingStatusOption: [
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},

    ]
  },
  SD: {
    status: negStatus,
    statusOption: negStatusOption,
  }
};

export const AdPlacementEnum = {
  SP: {
    type: {
      PLACEMENT_PRODUCT_PAGE: 'Detail Page on-Amazon',
      PLACEMENT_TOP: 'Top of Search on-Amazon',
      PLACEMENT_REST_OF_SEARCH: 'Other on-Amazon'
    },
    placementOption: [
      {id: 'PLACEMENT_PRODUCT_PAGE', text: '商品页面', realId: 'PLACEMENT_PRODUCT_PAGE'},
      {id: 'PLACEMENT_TOP', text: '搜索结果顶部（首页）', realId: 'PLACEMENT_TOP'},
      {id: 'PLACEMENT_REST_OF_SEARCH', text: '搜索结果的其余位置', realId: 'PLACEMENT_REST_OF_SEARCH'},
    ],
    strategyPlacementOption: [
      {id: 'PLACEMENT_PRODUCT_PAGE', text: '商品页面'},
      {id: 'PLACEMENT_TOP', text: '搜索结果顶部（首页）'},
    ],
    placementAliasOption: [
      {id: 'Detail Page on-Amazon', text: '商品页面'},
      {id: 'Top of Search on-Amazon', text: '搜索结果顶部（首页）'},
      {id: 'Other on-Amazon', text: '搜索结果的其余位置'},
    ],
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ]
  }
};

export const AdSearchWordEnum = {
  SP: {
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ]
  }
};

export const AdBidTypeEnum = {
  default: 0,
  targetGroup: 1
};

export const AdTargetTypeEnum = {
  keyword: '1',
  product: '2'
};

export const AdBidStrategyTypeEnum = {
  LEGACY_FOR_SALES: 'LEGACY_FOR_SALES',
  AUTO_FOR_SALES: 'AUTO_FOR_SALES',
  MANUAL: 'MANUAL',
};

export const AdBidStrategyTypeEnumOptions = [
  {id: 'LEGACY_FOR_SALES', text: '动态竞价-只降低'},
  {id: 'AUTO_FOR_SALES', text: '动态竞价-提高和降低'},
  {id: 'MANUAL', text: '固定竞价'},
];

// 超出预算的下拉框
export const BudgetStatus = () => {
    const cell = {
      normal: 'CAMPAIGN_STATUS_ENABLED',
      beyond: 'CAMPAIGN_OUT_OF_BUDGET'
    }
    const options = [
      {id: cell.normal, text: "预算正常"},
      {id: cell.beyond, text: "超出预算"}
    ]
    return {
      SP: { cell, options },
      SB: { cell, options },
      SD: { cell, options }
    }
}

// 广告组
export const GroupType = () => {
  const cell = {
    keyword: 0,
    product: 1,
    auto: 2,
  }
  const options = [
    {id: cell.keyword, text: "关键词投放"},
    {id: cell.product, text: "商品投放"},
    {id: cell.auto, text: "自动投放"},
  ]
  return {
    SP: { cell, options },
  }
}

/** 广告日志
 * @param custom: { objArr: [] }
 */
export const AdLog = (custom = {}) => {
  // 广告类型
  const adsType = {
    SP: 0,
    SB: 1,
    SD: 2,
  }
  const adsTypeOptions = [adsType.SP, adsType.SB, adsType.SD]
  // 操作类型
  const optCell = {
    add: 0,
    edit: 1
  };
  const optOptions = [
    {id: optCell.add, text: '新增'},
    {id: optCell.edit, text: '修改'}
  ];
  // 操作内容
  const contentCell = {
    name: 'name',
    state: 'state',
    price: 'price',
    bidding: 'bidding',
    startDate: 'startDate',
    endDate: 'endDate',
    portfolios: 'portfolios',
    percent: 'percent',
  };
  const contentOptions = [
    {id: contentCell.name, text: '名称'},
    {id: contentCell.state, text: '状态'},
    {id: contentCell.price, text: '预算/竞价'},
    {id: contentCell.bidding, text: '竞价策略'},
    {id: contentCell.endDate, text: '结束时间'},
    {id: contentCell.portfolios, text: '广告组合'},
  ];
  // 操作对象类型
  const objCell = {
    mix: '0',
    campaign: 1, // true
    group: 2,// true
    space: 3,// true
    commodity: 4,
    keyWord: 5,// true
    negativeKeyword: 6,
    campaignNegativeKeyword: 7,
    delivery: 8,// true
    deliveryMap: 10,// true
    negativeDelivery: 9
  };
  const objOptions = [
    {
      id: objCell.mix, text: '广告组合',
      optOptions: [
        { id: `${optCell.add}`, text: `新增广告组合`},
        { id: `${optCell.edit}-${contentCell.name}`, text: `修改广告组合`},
      ],
      sign: {
        isCampaign: false,
        isGroup: false,
      },
      isShare:false, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.campaign, text: '广告活动',
      optOptions: [
        { id: `${optCell.add}`, text: `新增广告活动`},
        { id: `${optCell.edit}-${contentCell.price}`, text: `调整预算`},
        { id: `${optCell.edit}-${contentCell.portfolios}`, text: `修改分组`},
        { id: `${optCell.edit}-${contentCell.endDate}`, text: `修改结束时间`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
        { id: `${optCell.edit}-${contentCell.name}`, text: `修改广告活动名称`},
        { id: `${optCell.edit}-${contentCell.bidding}`, text: `修改竞价策略`},
      ],
      sign: {
        isCampaign: false,
        isGroup: false,
      },
      id2:0,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.group, text: '广告组',
      optOptions: [
        { id: `${optCell.add}`, text: `新增广告组`},
        { id: `${optCell.edit}-${contentCell.price}`, text: `调整竞价`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
        { id: `${optCell.edit}-${contentCell.name}`, text: `修改广告组名称`},
      ],
      sign: {
        isCampaign: true,
        isGroup: false,
      },
      id2:1,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.space, text: '广告位',
      optOptions: [
        { id: `${optCell.edit}-${contentCell.percent}`, text: `修改广告位竞价`},
      ],
      sign: {
        isCampaign: true,
        isGroup: false,
      },
      id2:2,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.commodity, text: '商品',
      optOptions: [
        { id: `${optCell.add}`, text: `新增商品`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      isShare:false, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.keyWord, text: '关键词',
      optOptions: [
        { id: `${optCell.add}`, text: `新增关键词`},
        { id: `${optCell.edit}-${contentCell.price}`, text: `调整竞价`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      id2:3,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.negativeKeyword, text: '否定关键词',
      optOptions: [
        { id: `${optCell.add}`, text: `新增否定关键词`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      isShare:false, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.campaignNegativeKeyword, text: '活动否定关键词',
      optOptions: [
        { id: `${optCell.add}`, text: `新增活动否定关键词`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: false,
      },
      isShare:false, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.delivery, text: '商品投放',
      optOptions: [
        { id: `${optCell.add}`, text: `新增商品投放`},
        { id: `${optCell.edit}-${contentCell.price}`, text: `调整竞价`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      id2:4,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.deliveryMap, text: '投放组',
      optOptions: [
        { id: `${optCell.edit}-${contentCell.price}`, text: `调整竞价`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      id2:5,
      isShare:true, //true：手动、自动调整都有  false：只有手动调整
    },
    {
      id: objCell.negativeDelivery, text: '否定商品投放',
      optOptions: [
        { id: `${optCell.add}`, text: `新增否定商品投放`},
        { id: `${optCell.edit}-${contentCell.state}`, text: `修改状态`},
      ],
      sign: {
        isCampaign: true,
        isGroup: true,
      },
      isShare:false, //true：手动、自动调整都有  false：只有手动调整
    }
  ];
  // 配置
  const optOptionsCustom = (id) => {
    const item = objOptions.find(e => e.id === id);
    return item ? item.optOptions : [];
  }
  const getObjOptions = (id) => {
    const item = objOptions.find(e => e.id === id);
    return item ? item.sign : {};
  }
  //自动规则新增,查询id对应的text
  const getObjText = (id) => {
    const item = objOptions.find(e => e.id === id);
    return item ? item.text : null;
  }
   //自动规则新增,查询text对应的id
   const getObjId = (text) => {
    const item = objOptions.find(e => e.text === text);
    return item ? item.id : null;
  }
  // 操作结果
  const resultCell = {
    success: 0,
    fail: 1,
  };
  const resultOptions = [
    {id: resultCell.success, text: '成功'},
    {id: resultCell.fail, text: '失败'}
  ];
  // 操作时间类型
  const createDateCell = {
    system: 0,
    market: 1,
  };
  const createDateOptions = [
    {id: createDateCell.system, text: '北京时间'},
    {id: createDateCell.market, text: '站点时间'}
  ];
  return {
    adsType, adsTypeOptions,
    contentCell, contentOptions,
    objCell, objOptions,
    optOptionsCustom, getObjOptions,getObjText,getObjId,
    optCell, optOptions,
    resultCell, resultOptions,
    createDateCell, createDateOptions
  }
}

// 广告 各个国家默认竞价
export const AdDefaultBid = {
  US: {
    text: '美国',// 国家
    currencyName: '美元',// 货币名称
    currencyNameAbbreviation: 'USD',// 货币名称缩写
    currencySymbol: '$',// 货币符号
    SPDefaultBid: 0.75,// 商品广告默认竞价
    SBDefaultBid: 1,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  CA: {
    text: '加拿大',// 国家
    currencyName: '加拿大元',// 货币名称
    currencyNameAbbreviation: 'CAD',// 货币名称缩写
    currencySymbol: 'C$',// 货币符号
    SPDefaultBid: 0.6,// 商品广告默认竞价
    SBDefaultBid: 0.75,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  BR: {
    text: '巴西',// 国家
    currencyName: '巴西雷亚尔',// 货币名称
    currencyNameAbbreviation: 'BRL',// 货币名称缩写
    currencySymbol: 'R$',// 货币符号
    SPDefaultBid: null,// 商品广告默认竞价
    SBDefaultBid: null,//品牌广告默认竞价
    SDDefaultBid: null,//展示广告默认竞价
  },
  MX: {
    text: '墨西哥',// 国家
    currencyName: '墨西哥比索',// 货币名称
    currencyNameAbbreviation: 'MXN',// 货币名称缩写
    currencySymbol: 'Mex$',// 货币符号
    SPDefaultBid: 10,// 商品广告默认竞价
    SBDefaultBid: 10,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  UK: {
    text: '英国',// 国家
    currencyName: '英镑',// 货币名称
    currencyNameAbbreviation: 'GBP',// 货币名称缩写
    currencySymbol: '£',// 货币符号
    SPDefaultBid: 0.5,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  FR: {
    text: '法国',// 国家
    currencyName: '欧元',// 货币名称
    currencyNameAbbreviation: 'EUR',// 货币名称缩写
    currencySymbol: '€',// 货币符号
    SPDefaultBid: 0.4,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  IT: {
    text: '意大利',// 国家
    currencyName: '欧元',// 货币名称
    currencyNameAbbreviation: 'EUR',// 货币名称缩写
    currencySymbol: '€',// 货币符号
    SPDefaultBid: 0.4,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  ES: {
    text: '西班牙',// 国家
    currencyName: '欧元',// 货币名称
    currencyNameAbbreviation: 'EUR',// 货币名称缩写
    currencySymbol: '€',// 货币符号
    SPDefaultBid: 0.4,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  NL: {
    text: '荷兰',// 国家
    currencyName: '欧元',// 货币名称
    currencyNameAbbreviation: 'EUR',// 货币名称缩写
    currencySymbol: '€',// 货币符号
    SPDefaultBid: 0.4,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  DE: {
    text: '德国',// 国家
    currencyName: '欧元',// 货币名称
    currencyNameAbbreviation: 'EUR',// 货币名称缩写
    currencySymbol: '€',// 货币符号
    SPDefaultBid: 0.4,// 商品广告默认竞价
    SBDefaultBid: 0.95,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  AE: {
    text: '阿联酋',// 国家
    currencyName: '阿联酋迪拉姆',// 货币名称
    currencyNameAbbreviation: 'AED',// 货币名称缩写
    currencySymbol: 'AED',// 货币符号
    SPDefaultBid: null,// 商品广告默认竞价
    SBDefaultBid: null,//品牌广告默认竞价
    SDDefaultBid: null,//展示广告默认竞价
  },
  IN: {
    text: '印度',// 国家
    currencyName: '印度卢比',// 货币名称
    currencyNameAbbreviation: 'INR',// 货币名称缩写
    currencySymbol: '₹',// 货币符号
    SPDefaultBid: null,// 商品广告默认竞价
    SBDefaultBid: null,//品牌广告默认竞价
    SDDefaultBid: null,//展示广告默认竞价
  },
  JP: {
    text: '日本',// 国家
    currencyName: '日元',// 货币名称
    currencyNameAbbreviation: 'JPY',// 货币名称缩写
    currencySymbol: 'J￥',// 货币符号
    SPDefaultBid: 40,// 商品广告默认竞价
    SBDefaultBid: 50,//品牌广告默认竞价
    SDDefaultBid: 100,//展示广告默认竞价
  },
  AU: {
    text: '澳洲',// 国家
    currencyName: '澳元',// 货币名称
    currencyNameAbbreviation: 'AUD',// 货币名称缩写
    currencySymbol: 'A$',// 货币符号
    SPDefaultBid: 1,// 商品广告默认竞价
    SBDefaultBid: 1.4,//品牌广告默认竞价
    SDDefaultBid: 1,//展示广告默认竞价
  },
  SG: {
    text: '新加坡',// 国家
    currencyName: '新加坡元',// 货币名称
    currencyNameAbbreviation: 'SGD',// 货币名称缩写
    currencySymbol: 'S$',// 货币符号
    SPDefaultBid: null,// 商品广告默认竞价
    SBDefaultBid: null,//品牌广告默认竞价
    SDDefaultBid: null,//展示广告默认竞价
  },
  CN: {
    text: '中国',// 国家
    currencyName: '人民币',// 货币名称
    currencyNameAbbreviation: 'CNY',// 货币名称缩写
    currencySymbol: '￥',// 货币符号
    SPDefaultBid: null,// 商品广告默认竞价
    SBDefaultBid: null,//品牌广告默认竞价
    SDDefaultBid: null,//展示广告默认竞价
  },
}

export const RESOLVED_EXPRESSION_VALUE_MAP = {
  QUERY_BROAD_REL_MATCHES: { value: 'QUERY_BROAD_REL_MATCHES', hump: 'queryBroadRelMatches', label: '宽泛匹配' },
  QUERY_HIGH_REL_MATCHES: { value: 'QUERY_HIGH_REL_MATCHES', hump: 'queryHighRelMatches', label: '紧密匹配' },
  ASIN_SUBSTITUTE_RELATED: { value: 'ASIN_SUBSTITUTE_RELATED', hump: 'asinSubstituteRelated', label: '同类商品' },
  ASIN_ACCESSORY_RELATED: { value: 'ASIN_ACCESSORY_RELATED', hump: 'asinAccessoryRelated', label: '关联商品' },
  ASIN_CATEGORY_SAME_AS: { value: 'ASIN_CATEGORY_SAME_AS', hump: 'asinCategorySameAs', label: '分类匹配' },
  ASIN_SAME_AS: { value: 'ASIN_SAME_AS', hump: 'asinSameAs', label: '商品匹配' },
  ASIN_EXPANDED_FROM: { value: 'ASIN_EXPANDED_FROM', hump: 'asinExpandedFrom', label: '扩展匹配' },
  ASIN_BRAND_SAME_AS: { value: 'ASIN_BRAND_SAME_AS', hump: 'asinBrandSameAs', label: '跟...品牌一致' },
  ASIN_PRICE_LESS_THAN: { value: 'ASIN_PRICE_LESS_THAN', hump: 'asinPriceLessThan', label: '价格低于...' },
  ASIN_PRICE_BETWEEN: { value: 'ASIN_PRICE_BETWEEN', hump: 'asinPriceBetween', label: '价格介于...与...之间' },
  ASIN_PRICE_GREATER_THAN: { value: 'ASIN_PRICE_GREATER_THAN', hump: 'asinPriceGreaterThan', label: '价格大于...' },
  ASIN_REVIEW_RATING_LESS_THAN: { value: 'ASIN_REVIEW_RATING_LESS_THAN', hump: 'asinReviewRatingLessThan', label: '评分低于...' },
  ASIN_REVIEW_RATING_BETWEEN: { value: 'ASIN_REVIEW_RATING_BETWEEN', hump: 'asinReviewRatingBetween', label: '评分介于...与...之间' },
  ASIN_REVIEW_RATING_GREATER_THAN: { value: 'ASIN_REVIEW_RATING_GREATER_THAN', hump: 'asinReviewRatingGreaterThan', label: '评分大于...' },
  ASIN_AGE_RANGE_SAME_AS: { value: 'ASIN_AGE_RANGE_SAME_AS', hump: 'asinAgeRangeSameAs', label: '适用年龄' },
  ASIN_GENRE_SAME_AS: { value: 'ASIN_GENRE_SAME_AS', hump: 'asinGenreSameAs', label: '类型' },
  ASIN_IS_PRIME_SHIPPING_ELIGIBLE: { value: 'ASIN_IS_PRIME_SHIPPING_ELIGIBLE', hump: 'asinIsPrimeShippingEligible', label: '是否具有Prime资格' },
  OTHER: { value: 'OTHER', hump: 'other', label: '其他' },
}